@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.fieldContainer {
  display: flex;
  gap: 12px;

  /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
  @media (max-width: 450px) {
    margin: 0 auto;
  }

  .label {
    @include md-regular;
    color: var(--neutral-40);
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}

.formFieldContainer {
  display: flex;
}

.loadingContainer {
  width: 187px;
  display: flex;
  align-items: center;
  justify-content: center;

  @include for-phone-only {
    width: 100%;
  }
}

.languageFieldWrapper {
  width: 100%;
}

.languageFieldButton {
  @include md-sohne;
  @include transition;
  border-radius: 9px !important;
  color: var(--dark-80);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.09) !important;
  min-height: 46px;
  width: 100%;

  svg {
    color: var(--dark-40);
  }
}

.languageFieldPopover {
  min-width: 250px;

  div {
    @include hide-scrollbar;
  }
}

.secondary {
  background: var(--dark-4);
  border-radius: 6px;

  .contents {
    background: transparent;
    box-shadow: none;
    backdrop-filter: none;
  }

  .comboBoxInput {
    &::placeholder {
      color: var(--dark-80);
    }
  }
}

.mobileSelect {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--light-100);
  height: 40px;
  border-radius: 6px;
  box-shadow: 0px 2px 5px 0px #00000012, 0px 0px 4px 0px #00000008;

  .mobileChevron {
    position: absolute;
    display: flex;
    align-items: center;
    right: 12px;
    top: 0;
    height: 100%;
    flex: 1;
  }

  select {
    @include md-sohne;
    color: var(--dark-80);
    background: transparent;
    border: none;
    outline: none;
    box-shadow: none;
    padding: 0 30px 0 12px;
    height: 100%;
    flex: 1;
  }
}
